import { IPortabilityCMS } from '@vfit/consumer/data-access';

export const organizePortabilityInternetCard = (dataFromCms: IPortabilityCMS) => ({
  title: dataFromCms?.portability?.modalInfo?.title || '',
  description: dataFromCms?.portability?.modalInfo?.description || '',
});
